import { registerComponent } from '@gig/magic-common';
import CoinSwitcherTooltipComponent from './coin-switcher-tooltip.vue.js';

var CoinSwitcherTooltip = registerComponent(CoinSwitcherTooltipComponent);

export { CoinSwitcherTooltip };
